<template>
  <div class="tw-cursor-pointer" :class="buttonClass">
    <RenderMathQuestion
      :question-kind="format"
      :question="buttonData.label || buttonData.value"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import RenderMathQuestion from '../shared/RenderMathQuestion.vue';
import { SfMathLevelAnswerOption, SfMathLevelFormat } from '@/types/mathsTypes';

export default defineComponent({
  components: { RenderMathQuestion },
  props: {
    format: {
      type: String as PropType<SfMathLevelFormat>,
      default: 'text',
    },
    buttonData: { 
      type: Object as PropType<SfMathLevelAnswerOption>, 
      required: true 
    },
  },
  computed: {
    buttonClass() {
      if(this.buttonData.style == 'plain') {
        return null;
      }
      return 'sf-btn-' + this.buttonData.style;
    }
  }
});
</script>